module.exports = __webpack_public_path__ + "static/media/iPhone XS Copy 5.00fe2e05.png";